import { useCallback, useSyncExternalStore } from "react";

/** Subscribe to the browser directly, including pointer and orientation queries. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (notify: () => void) => {
      const media = window.matchMedia(query);
      if (media.addEventListener) {
        media.addEventListener("change", notify);
        return () => media.removeEventListener("change", notify);
      }
      media.addListener(notify);
      return () => media.removeListener(notify);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}
